import { SITE } from "@/config/siteConfig";

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

// Événements de conversion : prêts pour Meta Pixel, Google Analytics
// et Google Tag Manager. Les scripts se collent dans public/index.html.
export const trackEvent = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (typeof window.fbq === "function") {
    window.fbq("trackCustom", event, params);
  }
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
};
